import  './Footer.css';

export const Footer = () => {
    return (
        <footer className="footer">
        <p>1605 Palmales Ct., Las Vegas, NV 89128 Phone: (858) 324-1903 & (702) 430-8892</p>
        </footer>
    );
}